"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides an Iterator<T> implementation for the {@link FilterableCollection}.
 * @class
 */
class FilterableCollectionIterator {
    /**
     * Initializes a new instance of the {@link FilterableCollectionIterator<T>} class.
     * @param {Iterable<T>} items Collection of items to iterate through.
     * @param filters {IDictionary<any>} Dictionary of predicate-value pairs used for filtering.
     */
    constructor(items, filters) {
        this.items = items[Symbol.iterator]();
        this.filters = filters;
    }
    /** @inheritDoc */
    next() {
        const nextMatching = this.getNextMatchingItemFrom(this.items);
        if (nextMatching === null) {
            return { value: null, done: true };
        }
        return { value: nextMatching, done: false };
    }
    static isInArray(expectedValue, itemValue, predicate) {
        const currentPredicateValue = itemValue[predicate];
        if (!!currentPredicateValue &&
            currentPredicateValue[Symbol.iterator] &&
            typeof currentPredicateValue !== "string") {
            for (const item of currentPredicateValue) {
                if (item === expectedValue || (typeof expectedValue === "function" && expectedValue(item))) {
                    return true;
                }
            }
        }
        return false;
    }
    static matchesRegex(expectedValue, itemValue, predicate) {
        const currentPredicateValue = itemValue[predicate];
        return !!currentPredicateValue && expectedValue instanceof RegExp && expectedValue.test(currentPredicateValue);
    }
    static equals(expectedValue, itemValue, predicate) {
        const currentPredicateValue = itemValue[predicate];
        return ((typeof expectedValue === "function" && expectedValue(itemValue)) ||
            (!!currentPredicateValue &&
                !(currentPredicateValue instanceof Array) &&
                !(expectedValue instanceof RegExp) &&
                currentPredicateValue === expectedValue));
    }
    getNextMatchingItemFrom(iterator) {
        let item = iterator.next();
        while (!item.done) {
            let isMatch = true;
            for (const predicate of Object.keys(this.filters).filter(filter => !!item.value[filter] || filter.charAt(0) === "_")) {
                const expectedValue = this.filters[predicate];
                if (!FilterableCollectionIterator.equals(expectedValue, item.value, predicate) &&
                    !FilterableCollectionIterator.isInArray(expectedValue, item.value, predicate) &&
                    !FilterableCollectionIterator.matchesRegex(expectedValue, item.value, predicate)) {
                    isMatch = false;
                    break;
                }
            }
            if (isMatch) {
                return item.value;
            }
            item = iterator.next();
        }
        return null;
    }
}
exports.default = FilterableCollectionIterator;
//# sourceMappingURL=FilterableCollectionIterator.js.map